import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      // CHANGEMENT : Délai global d'affichage (en millisecondes)
      duration={8000} 
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          // CHANGEMENT : Ajout de !text-base (ou !text-lg) pour la taille de la police
          description: "group-[.toast]:!text-black group-[.toast]:!opacity-100 group-[.toast]:!text-base", 
          title: "group-[.toast]:!text-lg group-[.toast]:font-bold", // Titre un peu plus grand aussi
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:!text-black",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }